import './style.scss';
import register from 'ShopUiBundle/modules/app/registry';

// tslint:disable-next-line
register('form-password', () => import(/* webpackMode: "lazy" */'./form-password'));
